import { createFileRoute } from "@tanstack/react-router";

// This index route is intentionally empty.
// The recordings list is rendered by the parent recordings.route.tsx
// so it remains visible when a recording modal is opened.
export const Route = createFileRoute("/prospects/$prospectId/recordings/")({
  component: () => null
});
